import React, { useState, useEffect } from 'react';

async function fetchAlertConfig(token) {
  return fetch(process.env.REACT_APP_API_URL + '/app/configs', {
    headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }
  }).then(r => r.json()).catch(() => null);
}

async function saveAlertEmails(token, id, value) {
  return fetch(process.env.REACT_APP_API_URL + '/app/configs', {
    method: 'POST',
    headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' },
    body: JSON.stringify({ configs: [{ id, value }] })
  }).then(r => r.json()).catch(() => null);
}

export default function AlertSettings({ token }) {
  const [configId, setConfigId] = useState(null);
  const [emails, setEmails] = useState('');
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    fetchAlertConfig(token).then(data => {
      if (!data?.configs) return;
      const row = data.configs.find(c => c.key === 'alert_emails');
      if (row) {
        setConfigId(row.id);
        setEmails(row.value || '');
      }
    });
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccess(false);
    setError(false);
    const res = await saveAlertEmails(token, configId, emails);
    if (!res || res.error) {
      setError(true);
    } else {
      setSuccess(true);
    }
  };

  return (
    <div className="uk-card uk-card-default">
      <div className="uk-card-header">
        <h3 className="uk-card-title">Alert Notifications</h3>
      </div>
      <div className="uk-card-body">
        {error && (
          <div className="uk-alert-danger" uk-alert="">
            <p>Failed to save. Please try again.</p>
          </div>
        )}
        {success && (
          <div className="uk-alert-success" uk-alert="">
            <a className="uk-alert-close" uk-close=""></a>
            <p>Alert emails saved.</p>
          </div>
        )}
        <form className="uk-form-stacked" onSubmit={handleSubmit}>
          <div className="uk-margin">
            <label className="uk-form-label">
              Alert recipient emails <span style={{ color: '#888', fontWeight: 'normal' }}>(separate multiple with commas)</span>
            </label>
            <div className="uk-form-controls">
              <input
                className="uk-input"
                type="text"
                placeholder="email@example.com, another@example.com"
                value={emails}
                onChange={e => { setEmails(e.target.value); setSuccess(false); }}
              />
            </div>
            <p className="uk-text-small uk-text-muted" style={{ marginTop: 6 }}>
              These addresses receive an email whenever a client location has been idle for 3 consecutive weekdays.
            </p>
          </div>
          <button className="uk-button uk-button-default" type="submit" disabled={!configId}>
            Save
          </button>
        </form>
      </div>
    </div>
  );
}
